/* RESPONSIBLE TEAM: team-standalone */

import { CHANNEL_HUBSPOT_EMAIL_CONVERSATION } from 'embercom/lib/operator/custom-bots/constants';
import { ChannelTargetingBodyData } from '../definitions';

export default class HubspotChannelTargetingBodyData extends ChannelTargetingBodyData {
  get addMessengerChannel() {
    return true;
  }

  get channelGroupTitleKey() {
    return 'operator.workflows.channels.groupings.hubspot';
  }

  get channels() {
    return [
      {
        value: CHANNEL_HUBSPOT_EMAIL_CONVERSATION,
        icon: 'hubspot',
        requiresAppStoreInstallation: false,
        // eslint-disable-next-line @intercom/intercom/no-bare-strings
        channelTypeValue: 'HubSpot',
        isSetup: true,
      } as const,
    ];
  }
}
